import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { fg } from '@confluence/feature-gating';
import { LoadablePaint } from '@confluence/loadable';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const InferredProjectPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InferredProjectPage" */ './InferredProjectPage.tsx'
			)
		).InferredProjectPage,
});

type InferredProjectNavigationParams = {
	Screen: { screenEvent: { name: string } };
	MainLayout: { navView: string; disableMinWidth: boolean };
};

export const InferredProjectRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): InferredProjectNavigationParams;
} = (): React.JSX.Element => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (!fg('confluence_inferred_project_page_enabled')) {
		return <Redirection name={HOME.name} />;
	}

	return <InferredProjectPage />;
};

InferredProjectRoute.NAVIGATION_PARAMS = (): InferredProjectNavigationParams => ({
	Screen: {
		screenEvent: { name: 'inferredProjectPageScreen' },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		disableMinWidth: true,
	},
});
